import React from 'react';
import { Alert } from 'tea-component';
import { connect } from 'umi';
import { namespace } from '../model';
import {useDblIntl} from "@/pages/datalab/utils/utils";

export default connect((state: any, props: { hashEqual: boolean; }) => {
  const { hashEqual = true } = state[namespace];
  const { hashEqual: hashEqualProp } = props;
  return {
    hashEqual: hashEqualProp !== undefined ? hashEqualProp : hashEqual,
  };
})(AnalysisCalculateHint);
export function AnalysisCalculateHint(props: { hashEqual: boolean; }) {
  const {dblFormatMessage: explorationFormatMessage} = useDblIntl("exploration");
  return props.hashEqual !== true ? (
    <Alert type="warning" style={{ width: '100%', marginBottom: 0}}  className='alert-box' >
      {explorationFormatMessage("calculate_hint")}
    </Alert>
  ) : (
    <></>
  );
}

